import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { ContractCategoryLookupComponent } from './contract-category-lookup.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule
  ],
  declarations: [ContractCategoryLookupComponent],
  exports: [ContractCategoryLookupComponent],
  providers: []
})
export class ContractCategoryLookupModule { }
